/* eslint-disable quotes */
const en = {
  "AuthLoginFindAct" : "Forgot your ID or Password ?",
  "AuthLoginSbmBtn" : "Sign-in",
  "AuthFindTitle" : "Find ID & Password",
  "AuthFindReferId": "If you lose your ID \nplease contact the administrator",
  "AuthFindReferPw": "if you lose your password, \nplease enter the id and email and click the Find Password button",
  "AuthFindChgBtn": "Find Password",
  "AuthChgComp": "Company name change",

  "HeaderInfo": "MY INFO",
  "HeaderBody": "BODY COMPOSITION",
  "HeaderRank": "RANK",
  "HeaderMission": "MISSION",
  "HeaderChat": "CHATTING",
  "HeaderHealth": "HEALTH INDICATORS",
  "HeaderLogout": "LOGOUT",
  "MngHeaderDashboard": "DASHBOARD",
  "MngHeaderRank": "RANK",
  "MngHeaderMember": "MEMBER",
  "MngHeaderNoti": "NOTIFICATION",
  "MngHeaderChat": "CHATTING",
  "HeaderExercise": "EXERCISE PRESCRIPTION",
  "MngHeaderSetting": "SETTING",
  "MngHeaderMission": "MISSION",
  "MngHeaderLogout": "LOGOUT",

  "AccountPhd01": "Company Name",
  "AccountPhd02": "ID",
  "AccountPhd03": "Password",
  "AccountPhd04": "Password Check",
  "AccountPhd05": "Your registered E-mail address",
  "MyInfoCrudHeader": "My Info Edit",
  "MyInfo01": "Nickname",
  "MyInfo02": "E-Mail",
  "MyInfo03": "Gender",
  "MyInfo04": "Member Type",
  "MyInfo05": "Manager",
  "MyInfo06": "Phone",
  "MyInfo07": "Matching Manager",
  "MyInfo08": "Type",
  "MyInfo09": "Reg Date",
  "MyInfo10": "Last Measurement Date",
  "MyInfo11": "CheckIn",
  "MyInfo12": "Company Code",
  "MyInfo13": "Company Name",
  "MyInfo14": "Address",
  "MyInfo15": "Zip Code",
  "MyInfo16": "Country",
  "MyInfo17": "Member",

  "GraphHeader01": "My Body Composition Status",
  "GraphHeader02": "Weekly Mission Completion Rate",
  "GraphHeader03": "Weekly Goal Achievement Rate",

  "AnalysisProgressHeader01": "Low",
  "AnalysisProgressHeader02": "Normal",
  "AnalysisProgressHeader03": "High",
  "AnalysisProgressHeader04": "Very High",
  "BodyCompTitle01" : "Body Comp. Result",
  "BodyCompTitle02" : "Body Type",
  "BodyCompTitle03" : "BODY TYPE",
  "BodyCompTitle04" : "Diet Comment",
  "BodyCompTitle05" : "TO BE",
  "BodyCompAnalyText01" : "Comment",
  "BodyCompAnalyText02" : "Status",
  "BodyCompAnalyText03" : "Food",
  "BodyCompAnalyText04" : "Exercise",
  "BodyCompHeader01": "Analysis",
  "BodyCompHeader02": "Guide",
  "BodyCompHeader03": "To be",
  "BodyCompHeader04": "Trend",
  "BodyCompHeader05": "List",
  "BodyCompHeader06": "Result",
  "GoalTitle01" : "Current Data",
  "GoalTitle02" : "My Goal",
  "GoalTitle03" : "Recommedation Data",
  "Analysis": {
    "tableHeader": {
      "bfp": "BODY FAT PERCENTAGE",
      "bfm": "BODY FAT MASS",
      "smm": "SKELETAL MUSCLE MASS",
      "bmr": "BMR",
      "bmi": "BMI",
      "weight": "WEIGHT",
      "bwp": "BODY WATER",
      "bodyAge": "BODY AGE",
      "bodyType": "BODY TYPE",
      "bodyScore": "BODY SCORE",
      "stepScore": "STEP SCORE",
      "bodyFatAndSkeletalMuscleRatio": "BODY FAT/SKELETAL MUSCLE RATIO",
      "properBfp": "PROPER BFP",
      "protein": "PROTEIN",
      "minerals": "MINERALS",
      "ECWRatio": "EXTRACELLUAR FLUID RATIO"
    }
  },
  "GuideHeader01": "Ideal Data",
  "GuideHeader02": "Your Data",
  "DashGuide" : "The total number of gender, age and weight data is the total count when all three are entered",
  "RankGuide" : "• Total Ranking: Displays the ranking by converting the body composition and step counts scores into a 1:1 ratio. <br />• Body Composition Ranking: Ranked by body composition scores calculated after measuring body compositions.\n <br />• Step Counts Score: Ranked by a score calculated using the step counts synced into the user app.<br /> Scores are calculated as 70 points for 5000 steps, 100 points for 10000 steps, and 150 points for 20000 steps.",
  "RankBodyGuide": "The body score is converted to your body fat and skeletal muscle mass, \nYou can get high scores by lowering your body fat percentage and increasing your muscle percentage",
  "RankStepGuide": "The step score is a score that shows how much i have averaged over the \ncourse of a week. this score is the average number of steps per week",

  "UsrBodyComp": "Members' Body composition status" ,
  "UsrGoalAchieve": "Members' goal achievement rate",
  "UsrBodyCompComment": "It is a graph of changes in body composition status of members in a set period.",
  "UsrGoalAchieveComment": "It is a graph of the target achievement rate of members in the set period.",

  "HealthHeader01": "Bpm, SpO2",
  "HealthHeader02": "Blood Pressure",
  "HealthHeader03": "Stress",
  "HealthHeader04": "Sleep",
  "HealthHeader05": "Temperature",
  "HealthHeader06": "Steps",
  "HealthHeader07": "Run",
  "HealthHeader08" : "Blood Pressure\n(Input)",
  "HealthHeader09" : "Blood Sugar\n(Input)",
  "BpmHeader01": "Bpm(Beats Per Minute)",
  "BpmHeader02": "SpO2(Oxygen Saturation)",
  "StressHeader01": "Stress Index",
  "StepsUnit01": "Today Steps",
  "StepsUnit02": "Today distance walked",
  "StepsUnit03": "Today total calorie",
  "StepsUnit04": "Weekly total distance walked",
  "StepsUnit05": "Weekly total calorie",
  "StepsUnit06": "/10,000",
  "StepsUnit07": "km",
  "StepsUnit08": "Cal",
  "StepsUnit09": "Step",
  "StepsHeader01": "Total Steps",
  "StepsHeader02": "Smartphone",
  "StepsHeader03": "One Smart Diet Device",
  "TempHeader01": "Skin Temperature",
  "TempHeader02": "Surface Temperature",
  "TempListHeader01": "Category",
  "TempListHeader02": "Temperature",
  "OtherCtg01": "Date",
  "OtherCtg02": "Back View",
  "OtherCtg03": "Info",
  "OtherCtg04": "Actions",
  "OtherCtg05": "OTHERS",
  "OtherCtg06": "Success",
  "OtherCtg07": "All",
  "OtherCtg08": "Device",
  "OtherCtg09": "Completion",
  "OtherCtg10": "Point",
  "OtherCtg11": "Age",
  "OtherCtg12": "AVG",
  "MeasurementDatetime": "Measurement datetime",
  "Account": "ID",
  "Nickname": "Nickname",
  "device01": "ONE SMARTDIET",
  "device02": "FITRUS PLUS",
  "device03": "FITRUS LIGHT",
  "device04": "FITRUS MANAGER",
  "device05": "FITRUS A",
  "Notification": "Notification",

  "MngDashTotalAvgText01": "User",
  "MngDashTotalAvgText03": "Body Fat Mass(Avg.)",
  "MngDashTotalAvgText04": "Skeletal Muscle Mass(Avg.)",
  "MngDashCountText": "People",
  "MngDashCardHeadText01": "Total User & Gender",
  "MngDashCardHeadText02": "Total Age",
  "MngDashCardHeadText03": "Total Weight",
  "MngDashCardHeadText04": "Scatter Plot",
  "MngDashCardHeadText05": "Body Composition",
  "MngDashCardHeadText06": "Mission Completion Rate",
  "MngDashCardHeadText07": "Achievement Rate",
  "MngDashCardSelect01": "A Week",
  "MngDashCardSelect02": "One Month",
  "MngDashCardSelect03": "3 Month",
  "MngDashCardSelect04": "6 Month",
  "MngDashCardSelect05": "1 Year",
  "MngRankHelpText": "Body score rankings are ranked based on <br> the member's latest score. In addition, <br> steps are ranked by the average number <br> of steps per week in the latest week.",
  "MngRankCardHeadText01": "Members' Rank On Average",
  "MngMemberAddInfoTitle": "ADD MEMBER",
  "MngMemberListTitle": "MEMBER LIST",
  "MngMemberExcelDownload": "MEMBER LIST MEASURE DOWNLOAD",
  "MngMemberUnclassified": "Unclassed Member",

  "MngMember": {
    "actions": {
      "detail": "view detail",
      "excel": "download measure list",
      "edit": "edit",
      "resetPw": "reset password",
      "delete": "delete"
    }
  },

  "MngNoticeInfoTitle": "MISSION NOW",
  "MngNoticeTitle": "ALL LIST - NOTICE",
  "MngMissionTitle": "ALL LIST - MISSION",
  "MngNoticeCrud01": "Send Date",
  "MngNoticeCrud02": "Title",
  "MngNoticeCrud03": "Contents",
  "MngNoticeCrud04": "2nd Category",
  "MngNoticeCrud05": "Creator",
  "MngNoticeCrud06": "Last Modified Date",
  "MngNoticeCrud07": "Last Editor",
  "MngNoticeCrud08": "Category",
  "MngNoticeCrud09": "Message",
  "MngMyInfoCtg02": "Main Video In Login Screen",
  "MngMyInfoCtg03": "Attached-Video-File-Name",
  "MngMyInfoPwChg01": "Current Password",
  "MngMyInfoPwChg02": "New Password",
  "MngMyInfoPwChg03": "Confirm Password",
  "GenderF": "Female",
  "GenderM": "Male",
  "MemType01": "User",
  "MemType02": "Manager",
  "MngSctNot1st01": "Notice",
  "MngSctNot1st02": "Mission",
  "MngSctNot2ndMis01": "Nutrition",
  "MngSctNot2ndMis02": "Workout",
  "MngAlertListNoticeDel": "Are you sure you want to delete ? \nOnce deleted, it cannot be undone.",
  "MngAlertResetPW": "Do you want to reset password ?",
  "MngAlertListNoticeSend": "Do you want to send the selected \nnotice message to all members ?",
  "MngScatterPlot": "Scatter plot of body fat mass and skeletal muscle mass for all members",
  "MngBodyComp": "Body composition status of all members",
  "MngGoalAchieve": "All members' goal achievement rate",
  "MngMission": "All members' mission rate",
  "MngScatterPlotComment": "This is a graph of the variance of the body fat mass and skeletal muscle mass of the measured members in the set period.",
  "MngBodyCompComment": "It is a graph of changes in body composition status of all members in a set period.",
  "MngGoalAchieveComment": "It is a graph of the target achievement rate of all members in the set period.",
  "MngMissionComment": "It is a graph of the target mission rate of all members in the set period.",
  "MngMissionCtg": "EDIT - MISSION",
  "MngMissionNewCtg": "Add a Mission Topic",
  "MngMissionNewNote": "Add a Mission",
  "MngMissionSendTitle": "Send Mission",
  "MngMissionSendViewTitle": "Mission Details",
  "MngMissionCtg01": "Title",
  "MngMissionCtg02": "Contents",
  "MngMissionCtg03": "Topic",
  "MngMissionCtg04": "2st Category",
  "MngMissionCtg05": "Note",
  "MngMissionCtg06": "It allows you to attach up to 8MB",
  "MngMissionRate": "Mission Completion Rate",
  "ChooseMissionCategory": "Choose Mission Category",
  "Recipient": "Recipient",
  "AllMemberListForManager": "All members of the {{name}}",
  "AllMember": "All Members",
  "MissionStatus": "Mission Status",
  "Completed":"Completed",
  "Incomplete": "Incomplete",
  "MemberName": "Member Name",
  "MissionCompletion": "Mission Completion",
  "Status": "Status",
  "MissionLength": 45,

  "ButtonSave": "SAVE",
  "ButtonEdit": "EDIT",
  "ButtonCancel": "CANCEL",
  "ButtonClose": "CLOSE",
  "ButtonDelete": "DELETE",
  "ButtonSend": "SEND",
  "ButtonResend": "RESEND",
  "ButtonNewCtg": "NEW TOPIC",
  "ButtonNewNote": "NEW MISSION",
  "ButtonNewDelete": "DELETE MISSION",
  "ButtonTryAgain": "Try Again",
  "ButtonResetPass": "Reset Password",
  "ButtonChangePass": "Password Change",
  "ButtonAttachment": "Attachment",
  "ButtonSet": "Set",
  "ButtonDetail": "Detail",
  "ButtonConfirm": "Confirm",
  "ButtonSctImg": "Image Select",

  "ttlEdtProfile": "Edit Profile",
  "ttlAddMember": "Add Member",
  "ttlEditMember": "Edit Member",
  "ttlEditManager": "Edit Manager",
  "ttlAccInfo": "Account Information",
  "ttlCompInfo": "Company Information",
  "ttlPwInfo": "Password Information",
  "ttlUnitSet": "Unit Settings",
  "ttlCptLogo": "Corporate Logo Image",
  "ttlPmtLogo": "Corporate Promotion Image",
  "ttlChgPw": "Change Password",
  "ttlTotal": "TOTAL",
  "ttlBodyComp": "BODY COMP.",
  "ttlActivity": "ACTIVITY",
  "ttl": {
    "body": "Body score",
    "activity": "Step count",
    "calorie": "Calories burned",
    "bfp": "BFP",
    "bmi": "BMI",
    "subCategory": {
      "user": "Member",
      "manager": "Manager (Team)",
    },
    "unit": {
      "body": "pt",
      "activity": "step",
      "calorie": "cal",
      "bfp": "%",
      "bmi": "kg/m²",
    },
    "rank": {
      "rankAlt": "{rank} place medal image",
      "first": "First",
      "second": "Second",
      "third": "Third",
    },
    "excel": {
      "fileName": "순위_{{startDt}}_{{endDt}}",

      "column": {
        "rank": "순위",
        "memberSeq": "ID",
        "managerName": "팀명",
        "memberName":	"닉네임",

        "avg": "평균",

        "body": "신체 점수",
        "activity": "걸음 수",
        "calorie": "소모 칼로리",
        "bfp": "체지방",
        "bmi": "BMI",
      },
    },
  },
  "ttlCrtMsn": "Create a note.",
  "ttlChsTp": "Choose a topic.",
  "ttlDrop": "Drop image here or click to upload",
  "ttlDftPw": "Default Password",

  "lbDistance": "Distance",
  "lbTemperature": "Temperature",
  "lbWeight": "Weight",
  "lbHeight": "Height",
  "lbProfile": "Profile Image",
  "lbMsnImg": "Mission Image",
  "lbMsnCtg": "Mission Category",
  "lbCreator": "Creator",

  "SuccessSend": "Registered.",
  "SuccessEdit": "Changed.",
  "SuccessDelete": "Deleted.",
  "SuccessMail": "Mail has been send.",
  "SuccessEmail": "Email format is incorrect.",
  "SuccessSubmit": "Success.",
  "SuccessSave": "Success.",

  "ErrorNonReg": "This is an unregistered account.",
  "ErrorBlank": "Please fill out all the items.",
  "ErrorBlankTopic": "Please enter a topic.",
  "ErrorBlankNote": "Please enter a Note.",
  "ErrorBlankTitle": "Please enter a title.",
  "ErrorPwNotMatch": "The new password does not match.",
  "ErrorCurrnetPwNotMath": "The current password does not match.",
  "ErrorCurrnetPw": "You cannot change to an existing password.",
  "ErrorCheckComp": "Please check the name of the company.",
  "ErrorCheckId": "Please check your ID or password.",
  "ErrorCheckEmail": "Please check your ID or Email.",
  "ErrorSelectCtg": "Please select the mission(s) what you want to send.",
  "ErrorDeleteCtg": "Please select the mission(s) what you want to delete.",
  "ErrorNoData": "Measure your {{type}}.",
  "ErrorNotAuth": "You don't have authority",
  "ErrorIdDuplicate": "This ID is already in use.",
  "ErrorIdType": "The ID must be 6 to 40 characters including at least one upper or lower case letter, number, or special symbol (-_ @.).",
  "ErrorIdForbidden": "You have entered it incorrectly more than 5 times. Please contact the administrator or use the Find Password",
  "ErrorPwType": "Password must be between 8 and 20 characters including upper and lower case letters, numbers, and special symbols (!#$%&*+-./:;=?@＼^_`~).",
  "ErrorImgFormat": "The format is not supported.",
  "ErrorNotChooseRecipient": "Please select a Recipient.",
  "ErrorNotImg": "Please select an image.",
  "ErrorNoMission": "No missions have been received.",
  "ErrorNotMeasurementList": "There is no record of your measurement.",
  "ErrorMissionDownload": "Please select the date, topic & contents of the mission to download.",
  "ErrorMissionEmpty": "There are no missions corresponding to the date, topic & content you selected.",
  "ErrorImgMax5": "Up to five pictures can be uploaded.",

  "Start": "Start",
  "Current": "Current",
  "Goal": "Goal",
  "All": "All",

  "GoalSetting": "Goal Settings",
  "Somato01": "What is Somato Body Shape?",
  "Somato02": "Meaning of body numbers",
  "Somato03": "Somatotype body type is a body type classification method developed by Sheldon \non the assumption that the external body shape changes \ndepending on the relative development of the tissue. \n\nThe body type number is an arrangement of three numbers \nas a pair by classifying the components that make up the body \ninto endoderm, mesoderm, and ectoderm \n(each vertex of a triangle-shaped chart)\nand evaluating three elements in 9 steps.",
  "Somato04": "* Endomorph \n The first digit. A body type with a more developed belly than the chest with a rounded body shape due to the development of subcutaneous fat.",
  "Somato05": "* Mesomorph \n The middle digit. A muscular body type with developed motor muscles.",
  "Somato06": "* Ectomorphic \n The Last digit. The ectodermal skin tissue, nerves and sensory systems are well developed, but the muscles are undeveloped and the body is thin and weak.",
  "MissionSucList": "Achievement History",
  "MissionSuc": "Achievement History",
  "MissionComment": "Mission Comment",

  "Download": "Download",
  "DownloadMeasureList": "Do you want to download the measurement record?",
  "DownloadRank": "Do you want to download the rank record?",
  "SelectDate": "Choose Period",

  "Topic&Cnt": "Topic & Contents",
  "MissionDte": "Mission Date",
  "Name": "Name",
  "FitrusBand": "Fitrus Band",
  "FitrusPlus": "Fitrus Plus",

  "RunningDte": "Running Date",
  "TotalDistance": "Total Distance",
  "RunningCnt": "Running Count",
  "AvgPace": "Average Pace",
  "AvgHeartRate": "Average Bpm",
  "Calorie": "Calorie",
  "BloodPressure":"Blood Pressure",
  "BloodSugar": "Blood Sugar",
  "MeasurementTime": "Measurement Time",
  "MeasurementList": "Measurement List{{extra}}",
  "TeamMeasurementList": "Team Measurement List{{extra}}",
  "TeamStepCountList": "step count list",
  "TeamHRVList": "HRV",
  "TeamHRVDetailList": "HRV Detail",
  "Min": "Min",
  "Max": "Max",
  "Highest": "Highest",
  "Lowest": "Lowest",
  "Average": "Average",
  "MaxBP": "Max. BP",
  "MinBP": "Min. BP",
  "systolic": "systolic",
  "diastolic": "diastolic",
  "EmptyStomach": "fasting state",
  "BeforeEat": "before Meal",
  "AfterEat": "after Meal",
  "medicine": "medicine",
  "NotUse": "Not Use",
  "NotTake": "Not Take",
  "Take": "Take",
  "MyToBe": "My To be",
  "Hour": "h",
  "Minute": "m",

  "SearchByRange": "Search by range",
  "BedTime": "Bed time",
  "WakeUpTime": "Wake-up time",
  "AwakeCount": "Awake count",
  "DeepSleepTime": "Deep sleep time",
  "ShallowSleepTime": "Shallow sleep time",
  "TotalSleepTime": "Total sleep time",
  "AvgSleepTime": "Avg Sleep Time",
  "DeepSleep": "Deep Sleep",
  "AvgDeepSleep": "Average Deep Sleep",
  "ShallowSleep": "Shallow Sleep",
  "AvgShallowSleep": "Avg Shallow Sleep",
  "Insomnia": "Insomnia",
  "AvgInsomnia": "Avg Insomnia",
  "MySleepScore": "Individual Sleep Score",
  "AvgGroupSleepScore": "Group Avg Sleep Score",
  "AvgAllMySleepScore": "Individual Avg Sleep Score",
  "SleepScoreUnit": "pt",
  "AvgShort" : "avg.",
  "Activity": "Activity",
  "AM": "AM",
  "PM": "PM",
  "Normal": "Normal",

  "MinAgo": " minutes ago",
  "HourAgo": " hour ago",
  "JustBefore": "Just before",
  "AttachedImage": "Attached Image",
  "ReplyTo": "Reply To {{name}}",
  "Reply": "Reply",
  "Me": "Me",
  "KL": "EL",
  "NewMessage": "New message",

  "misc": {
    "select": "select",
    "cancel": "cancel",

    "date": {
      "mon": "mon",
      "tue": "tue",
      "wed": "wed",
      "thu": "thu",
      "fri": "fri",
      "sat": "sat",
      "sun": "sun"
    },

    "month": {      
      "1": "Jan",
      "2": "Feb",
      "3": "Mar",
      "4": "Apr",
      "5": "May",
      "6": "Jun",
      "7": "Jul",
      "8": "Aug",
      "9": "Sep",
      "10": "Oct",
      "11": "Nov",
      "12": "Dec"
    },

    "excel": {
      "teamName": "team name",
      "date": "date",
      "stepCount": "step count",
      "abdomen": "Abdominal circumference",
      "obesity": "Obesity",
      "recommendedDailyCalorieIntake": "Recommended daily calorie intake",

      "memos": {
        "recommended": "Maintain current weight",
      },

      "rangeDesc": "Excel download date range select",

      hrv: 'HRV',
      measureSource: {
        index: 'Measure source',
        hr: 'HR',
        stress: 'Stress',
        band: 'Fitrus Band',
        stress2: 'HRV',
      },

      fatigueIndex: 'Fatigue Index',
      healthIndex: 'Health Index',
      sri: 'Stress Resistance Index',
      spo2: 'SpO₂',
      hr: 'HR',
      lfPower: 'LF Power',
      hfPower: 'HF Power',
      lfHfRatio: 'LF/HF Ratio',
      sdnn: 'SDNN',
      rmssd: 'RMSSD',
      pnn50: 'pNN50',
      sd1: 'SD1',
      sd2: 'SD2',
    },

    "profileAlt": "{user}'s profile image",
  }
}

export default en